import { CustomEventId } from '../CustomEventId.enum';

export class CustomEventPublisher {

    public static sendEventWith(identifier: CustomEventId) {
        window.dispatchEvent(new CustomEvent(identifier));
    }

}
